import styled from 'styled-components'

/**
 * The answer is the one thing on this page that gets attention, so everything
 * else stays quiet: one column at a readable measure, no frames, no colour
 * beyond Miranda's own text and surface tokens.
 */
export const StyledChat = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--m-spacing-3);
  width: 100%;
  max-width: 760px;
  /* dvh follows the visible viewport on phones, where vh ignores the browser bars. */
  height: calc(100vh - 128px);
  height: calc(100dvh - 128px);
  min-height: 420px;
  margin: 0 auto;

  /* Counts and rates in an answer line up on the digit. */
  [data-message-role='assistant'] table {
    font-variant-numeric: tabular-nums;
  }
`

export const StyledConversation = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`

export const StyledStarters = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: var(--m-spacing-4);
  padding: var(--m-spacing-4) 0;
`

export const StyledStarterList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--m-spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
`

export const StyledStarter = styled.button`
  width: 100%;
  padding: var(--m-spacing-3) var(--m-spacing-4);
  border: var(--m-border-thin) solid rgb(var(--m-color-border));
  border-radius: var(--m-border-radius-m);
  background-color: rgb(var(--m-color-background-primary));
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  line-height: var(--m-line-height-5);
  text-align: left;
  color: rgb(var(--m-color-primary-100));
  cursor: pointer;

  &:hover {
    background-color: rgb(var(--m-color-background-highlight));
  }

  &:focus-visible {
    outline: 2px solid rgb(var(--m-color-brand));
    outline-offset: 2px;
  }
`

export const StyledComposer = styled.div`
  padding-bottom: var(--m-spacing-3);
`

/** Stop sits right above the composer while an answer runs, out of the way of the answer. */
export const StyledStopRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: var(--m-spacing-2);
`

export const StyledStop = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--m-spacing-1);
  padding: var(--m-spacing-1) var(--m-spacing-3);
  border: var(--m-border-thin) solid rgb(var(--m-color-border));
  border-radius: var(--m-border-radius-m);
  background-color: rgb(var(--m-color-background-primary));
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  font-weight: var(--m-font-weight-medium);
  color: rgb(var(--m-color-primary-100));
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: rgb(var(--m-color-background-highlight));
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid rgb(var(--m-color-brand));
    outline-offset: 2px;
  }

  /* On touch the button is a real target. */
  @media (hover: none) {
    min-height: 44px;
  }
`

export const StyledNotice = styled.p`
  margin: var(--m-spacing-2) 0 0;
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-2);
  line-height: var(--m-line-height-5);
  color: rgb(var(--m-color-text-tertiary));
`

